module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("注文入力")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("新規注文入力")]), _vm._v(" "), _c('splitter', {
    attrs: {
      "margin": 20
    }
  }, [_c('div', {
    slot: "left-pane"
  }, [_c('div', [_c('span', [_vm._v("注文番号")]), _c('span', [_vm._v(_vm._s(_vm.order_no))]), _vm._v(" "), _c('span', [_vm._v("送り主顧客番号")]), _c('span', [_vm._v(_vm._s(_vm.send_customer_id))])]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("宛先追加")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised",
    on: {
      "click": _vm.delete_order
    }
  }, [_vm._v("選択した宛先を消す")]), _vm._v(" "), _vm._l((_vm.details), function(detail) {
    return _c('li', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (detail.selected),
        expression: "detail.selected"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'ordercheck' + detail.receive_customer_id
      },
      domProps: {
        "checked": Array.isArray(detail.selected) ? _vm._i(detail.selected, null) > -1 : (detail.selected)
      },
      on: {
        "__c": function($event) {
          var $$a = detail.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (detail.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (detail.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            detail.selected = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'ordercheck' + detail.receive_customer_id
      }
    }, [_vm._v(_vm._s(detail.product_id) + ":" + _vm._s(detail.receive_customer_id))])])
  })], 2), _vm._v(" "), _c('div', {
    slot: "right-pane"
  }, [_c('customer-list')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-424f6446","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Order.vue
// module id = 209
// module chunks = 1